import { dispatchEvent } from 'redux-ruleset'
import { SeriesContainer } from './types'

export const mount = (countainer: SeriesContainer) =>
  dispatchEvent({
    type: 'templates/Series/MOUNT' as const,
    container: countainer
  })

declare global {
  interface RulesetDispatchEvents {
    'templates/Series': ReturnType<typeof mount>
  }
}
